import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=766d3976&scoped=true&"
import script from "./inicio.vue?vue&type=script&lang=js&"
export * from "./inicio.vue?vue&type=script&lang=js&"
import style0 from "./inicio.vue?vue&type=style&index=0&id=766d3976&scoped=true&lang=scss&"
import style1 from "./inicio.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766d3976",
  null
  
)

export default component.exports